import * as React from 'react'

export const StageReward = props => (
  <svg
    width={72}
    height={81}
    viewBox="0 0 72 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12628)">
      <path
        d="M33.6044 8.4047C35.0837 7.5373 36.9163 7.5373 38.3956 8.4047L61.3724 21.8777C62.8222 22.7277 63.7128 24.2825 63.7128 25.9631V53.0369C63.7128 54.7175 62.8222 56.2723 61.3724 57.1223L38.3956 70.5953C36.9163 71.4627 35.0837 71.4627 33.6044 70.5953L10.6276 57.1223C9.17784 56.2723 8.28719 54.7175 8.28719 53.0369V25.9631C8.28719 24.2825 9.17784 22.7277 10.6276 21.8777L33.6044 8.4047Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.6236 15.3677C35.0932 14.5153 36.9067 14.5153 38.3763 15.3677L55.9311 25.5506C57.3917 26.3979 58.2907 27.9587 58.2907 29.6473V50.0517C58.2907 51.7402 57.3917 53.3011 55.9311 54.1483L38.3763 64.3313C36.9067 65.1837 35.0932 65.1837 33.6236 64.3313L16.0689 54.1483C14.6083 53.3011 13.7092 51.7402 13.7092 50.0517V29.6473C13.7092 27.9587 14.6083 26.3979 16.0689 25.5506L33.6236 15.3677Z"
        fill="#F06106"
      />
      <g filter="url(#filter1_d_81_12628)">
        <path
          d="M36.9677 27.9673C41.5557 27.9674 45.2751 31.6869 45.2753 36.2749V36.48H58.2607V43.5112H45.2753V44.6216C45.275 47.8917 42.6171 50.5425 39.3388 50.5425H32.661C29.3827 50.5425 26.7248 47.8917 26.7245 44.6216V43.5112H13.7392V36.48H26.7245V36.2749C26.7247 31.6869 30.4441 27.9674 35.0321 27.9673H36.9677Z"
          fill="#FFB511"
        />
      </g>
      <path
        d="M36.0003 34.2581C37.921 34.2583 39.4776 35.8225 39.4778 37.7523C39.4778 39.124 38.6909 40.3101 37.5462 40.8821V44.7415C37.5462 45.5992 36.8539 46.2951 36.0003 46.2952C35.1465 46.2952 34.4544 45.5993 34.4544 44.7415V40.8821C33.3094 40.3102 32.5218 39.1241 32.5218 37.7523C32.522 35.8225 34.0794 34.2581 36.0003 34.2581Z"
        fill="#F06106"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12628"
        x="-4"
        y="0"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12628"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12628"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_81_12628"
        x="13.7392"
        y="27.9673"
        width="44.5215"
        height="23.9044"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.32923" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12628"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12628"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
